import React, { createContext, useContext } from 'react';

/**
 * Page numbering for the printable documents. On its own each document is
 * numbered from 1; inside the combined proposal the same pages are offset so
 * the footers read 1–3 of 3.
 */
interface DocPaging {
  offset: number;
  total: number;
}
const DocPagingContext = createContext<DocPaging>({
  offset: 0,
  total: 2
});
export function DocPagingProvider({
  offset,
  total,
  children
}: DocPaging & {
  children: React.ReactNode;
}) {
  return <DocPagingContext.Provider value={{
    offset,
    total
  }} data-id="element-1756" data-mp="lp5cggofa733">
      {children}
    </DocPagingContext.Provider>;
}
export function useDocPaging() {
  const {
    offset,
    total
  } = useContext(DocPagingContext);
  return {
    /** Absolute page number for a page's position in its own document. */
    page: (n: number) => n + offset,
    /** Footer label, e.g. "Page 3 of 4". */
    label: (n: number) => `Page ${n + offset} of ${total}`
  };
}